import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Ahora me explica él a mí cómo funciona el cuerpo.',
    author: 'María G.',
    role: 'Mamá de Tomás, 8 años'
  }, {
    quote: 'Le encanta aprender con esto.',
    author: 'Carolina P.',
    role: 'Mamá de Valentina, 7 años'
  }, {
    quote: 'Por fin entendió lo que antes no podía.',
    author: 'Laura F.',
    role: 'Mamá de Mateo, 9 años'
  }];
  return <section className="bg-gray-50 py-10 px-4" data-id="element-169">
      <div className="max-w-3xl mx-auto" data-id="element-170">
        <h2 className="text-2xl md:text-3xl font-black text-center text-gray-900 mb-6 font-['Oswald'] uppercase" data-id="element-171">
          ⭐ Lo que están diciendo otros padres
        </h2>

        <div className="space-y-3" data-id="element-172">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-4 rounded-lg shadow-md border-l-4 border-green-500 flex items-start gap-4" data-id="element-173">
              <div className="flex-1" data-id="element-174">
                <div className="flex gap-0.5 text-yellow-400 mb-2" data-id="element-175">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-176" />)}
                </div>
                <p className="text-base font-medium text-gray-800 italic mb-2" data-id="element-177">
                  "{t.quote}"
                </p>
                <p className="text-sm font-bold text-gray-900" data-id="element-178">{t.author}</p>
                <p className="text-xs text-gray-500" data-id="element-179">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}